<app-loader *ngIf="dataLoading"></app-loader>
<form *ngIf="!dataLoading" [formGroup]="userCreateEditForm">
  <app-loader *ngIf="userSaveOrEditLoading"></app-loader>
  <steps (onSaveStepsCallback)="onSaveStepsCallback()" (onResetStepsCallback)="onResetStepsCallback()">
    <step [title]="'Шаг 1'" [description]="'Личные данные<br>Транспортное средство<br>Контакты<br>Место работы'">
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">Личные данные</div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-9">
                  <div class="grid grid--va-middle">
                    <div class="grid__box grid__box--size-4">
                      <span class="title title-vertical title--s title--required">Фамилия</span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <app-field>
                        <input
                          class="input-text"
                          type="text"
                          (input)="onChangeNames($event, 'last_name')"
                          fieldTrim
                          fieldCapitalizeFirst
                          id="lastName"
                          formControlName="last_name"
                        />
                      </app-field>
                    </div>
                  </div>
                  <div class="grid mt-16 grid--va-middle">
                    <div class="grid__box grid__box--size-4">
                      <span class="title title-vertical title--s title--required">Имя</span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <app-field>
                        <input class="input-text" (input)="onChangeNames($event, 'first_name')" fieldTrim fieldCapitalizeFirst id="firstName" formControlName="first_name" />
                      </app-field>
                    </div>
                  </div>
                  <div class="grid mt-16 grid--va-middle">
                    <div class="grid__box grid__box--size-4">
                      <span class="title title-vertical title--s">Отчество</span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <app-field>
                        <input
                          class="input-text"
                          (input)="onChangeNames($event, 'patronymic_name')"
                          fieldTrim
                          fieldCapitalizeFirst
                          id="patronymicName"
                          formControlName="patronymic_name"
                        />
                      </app-field>
                    </div>
                  </div>
                  <div class="grid mt-16 grid--va-middle">
                    <div class="grid__box grid__box--size-4">
                      <span class="title title-vertical title--s title--required">Дата рождения</span>
                    </div>
                    <div class="grid__box grid__box--size-4">
                      <input type="hidden" id="birthDay" formControlName="birthday" />
                      <app-date-time-picker
                        [initDate]="birthDateObj.initDate"
                        [isShowTimepicker]="false"
                        [datepickerName]="'birthDate'"
                        [options]="birthDateOptions"
                        [checkAdult]="'14'"
                        (dateCallback)="onChangeBirthDate($event)"
                      ></app-date-time-picker>
                      <div class="label__error" *ngIf="birthDateObj && birthDateObj.selectedDate && birthDateObj.selectedDate.validationError">Неверная дата</div>
                    </div>
                  </div>
                  <div class="grid mt-16 grid--va-middle">
                    <div class="grid__box grid__box--size-4">
                      <span class="title title-vertical title--s">Координаты дома</span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <div class="grid grid--gap-8 grid--va-middle">
                        <div class="grid__box grid__box--size-4">
                          <app-field>
                            <input class="input-text" type="text" id="homeLatitude" placeholder="Широта" formControlName="home_latitude" fieldTrim />
                          </app-field>
                        </div>
                        <div class="grid__box grid__box--size-4">
                          <app-field>
                            <input class="input-text" type="text" id="homeLongitude" placeholder="Долгота" formControlName="home_longitude" fieldTrim />
                          </app-field>
                        </div>
                        <div class="grid__box grid__box--size-4">
                          <button class="button button--small" type="button" [disabled]="!getHomeMapUrl()" (click)="openHomeCoordinateMap()">На карте</button>
                        </div>
                      </div>
                      <div class="label__error" *ngIf="userCreateEditForm.get('home_latitude').invalid || userCreateEditForm.get('home_longitude').invalid">
                        Укажите корректные широту и долготу
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid__box grid__box--size-2">
                  <div class="photo-block">
                    <div class="photo-block__img">
                      <div class="img__empty" *ngIf="!isExistImage">
                        <label for="collaboratorsFileUpload" class="empty__text">
                          <span class="link link--dotted-gray-dark">Добавить фото</span>
                        </label>
                        <input class="input-file" id="collaboratorsFileUpload" type="file" accept=".png, .jpg" (change)="handleFileInput($event)" />
                      </div>
                      <div class="img__exists" *ngIf="isExistImage">
                        <img *ngIf="image" [src]="imagePreviewSrc" />
                        <img
                          *ngIf="currentSelectedUser && currentSelectedUser.employee.photo && !image"
                          src="{{ environment.apiPrefix + '/admin/users/' + currentSelectedUser.employee.e_id + '/userpic/' }}"
                        />
                      </div>
                    </div>
                    <div class="photo-block__description" *ngIf="!isExistImage" [ngbPopover]="uploadFileDescription" [placement]="'right'">
                      <a class="link link--dotted-gray-dark">Требования к фотографии</a>
                    </div>
                    <div class="photo-block__description" id="appRemovePhotoCollaborator" *ngIf="isExistImage" (click)="onRemovePreview()">
                      <a class="link link--dotted-red-dark">Удалить</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid mt-24 mb-24">
        <div class="grid__box--size-4">
          <div class="grid">
            <div class="grid__box grid__box--size-5">
              <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">
            Транспортное<br />
            средство
          </div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-12">
                  <div class="grid grid--va-middle">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s">Наличие</span>
                    </div>
                    <div class="grid__box grid__box--size-9">
                      <div class="grid grid--gap-32">
                        <div class="grid__box grid__box--size-min">
                          <app-radio-button>
                            <input type="radio" id="tfStatus1" formControlName="tf_status" value="1" />
                            <radio-button-text>Да</radio-button-text>
                          </app-radio-button>
                        </div>
                        <div class="grid__box grid__box--size-min">
                          <app-radio-button>
                            <input type="radio" id="tfStatus0" formControlName="tf_status" value="0" />
                            <radio-button-text>Нет</radio-button-text>
                          </app-radio-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s">Гос. номер</span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <div class="grid grid--va-middle">
                        <div class="grid__box grid__box--size-4">
                          <app-field>
                            <input class="input-text" type="text" id="tfNumber" formControlName="tf_number" fieldTrim fieldRegexp [regexp]="'[^a-zA-Zа-яА-Я0-9]'" />
                          </app-field>
                        </div>
                        <div class="grid__box ta-right">
                          <span class="title title-vertical title--s">Модель</span>
                        </div>
                        <div class="grid__box grid__box--size-4">
                          <app-field>
                            <input class="input-text" type="text" id="tfModel" formControlName="tf_model" fieldTrim />
                          </app-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid mt-24 mb-24">
        <div class="grid__box--size-4">
          <div class="grid">
            <div class="grid__box grid__box--size-5">
              <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">Контакты</div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-12">
                  <div class="grid grid--va-middle">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">Основной номер</span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <div class="grid grid--va-middle">
                        <div class="grid__box grid__box--size-4">
                          <app-field>
                            <input
                              class="input-text"
                              type="text"
                              id="phone"
                              prefix="+7 "
                              mask="000 000-00-00"
                              [showMaskTyped]="true"
                              (focusout)="handleFocusOut()"
                              formControlName="phone"
                            />
                          </app-field>
                        </div>
                        <div class="grid__box ta-right">
                          <span class="title title-vertical title--s">Доп. номер</span>
                        </div>
                        <div class="grid__box grid__box--size-4">
                          <app-field>
                            <input
                              class="input-text"
                              type="text"
                              id="phoneAdditional"
                              prefix="+7 "
                              mask="000 000-00-00"
                              [showMaskTyped]="true"
                              formControlName="phone_additional"
                            />
                          </app-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">E-mail</span>
                    </div>
                    <div class="grid__box grid__box--size-6">
                      <app-field>
                        <input class="input-text" type="text" id="email" (focusout)="handleFocusOut()" formControlName="email" fieldTrim />
                      </app-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid mt-24 mb-24">
        <div class="grid__box--size-4">
          <div class="grid">
            <div class="grid__box grid__box--size-5">
              <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">Место работы</div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-12">
                  <div class="grid grid--va-middle">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">Компания</span>
                    </div>
                    <div class="grid__box grid__box--size-7 dropdown-menu--small">
                      <input type="hidden" formControlName="partnership_id" />
                      <app-combobox
                        [items]="companiesList"
                        (callback)="onChangeCompany($event)"
                        [textKey]="'new_company_name'"
                        [defaultText]="'Выберите компанию'"
                        [initBy]="companySelected"
                        [name]="'partnershipId'"
                        [isDisabled]="!canEditCompany"
                      ></app-combobox>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s" [class.title--required]="userCreateEditForm.controls['personnel_number'].enabled"
                        >Табельный номер<br />
                        подрядчика</span
                      >
                    </div>
                    <div class="grid__box grid__box--size-7">
                      <app-field>
                        <input type="text" class="input-text" formControlName="personnel_number" (focusout)="handleFocusOut()" id="personnel_number" />
                      </app-field>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">Служебная функция</span>
                    </div>
                    <div class="grid__box grid__box--size-7 dropdown-menu--small">
                      <input type="hidden" formControlName="service_function_id" />
                      <app-select
                        [items]="serviceFunctionsList"
                        (callback)="onChangeServiceFunction($event)"
                        [textKey]="'service_function_name'"
                        [defaultText]="'Выберите служебную функцию'"
                        [initBy]="serviceFunctionSelected"
                        [name]="'serviceFunctionId'"
                      ></app-select>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">
                        Табельный<br />
                        номер ВК
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-7">
                      <app-field>
                        <input class="input-text" type="text" fieldTrim (focusout)="handleFocusOut()" id="empNumber" formControlName="emp_number" />
                      </app-field>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16" *ngIf="isAdministrator">
                    <div class="grid__box grid__box--size-3">
                      <label for="qualificationCoefficient" class="title title-vertical title--s title--required">Коэффициент сотрудника</label>
                      <button
                        type="button"
                        class="employee-coefficient-info"
                        aria-label="О коэффициенте сотрудника"
                        ngbPopover="Влияет на расчёт времени работы: чем ниже коэффициент, тем опытнее инженер и меньше времени требуется."
                        triggers="mouseenter:mouseleave focusin:focusout"
                        placement="top"
                      >i</button>
                    </div>
                    <div class="grid__box grid__box--size-7 dropdown-menu--small">
                      <app-select
                        [items]="qualificationCoefficients"
                        [textKey]="'label'"
                        [initBy]="qualificationCoefficientSelected"
                        [name]="'qualificationCoefficient'"
                        (callback)="userCreateEditForm.get('qualification_coefficient').setValue($event.value)"
                      ></app-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </step>
    <step [title]="'Шаг 2'" [description]="'Роли<br>Участки'">
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">Роли</div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-12">
                  <div class="grid">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">
                        Доступные<br />
                        сотруднику роли
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-9">
                      <div class="grid">
                        <div class="grid__box grid__box--size-6 mb-16" *ngFor="let role of roles; let i = index">
                          <app-checkbox>
                            <input type="checkbox" id="{{ 'role' + i }}" name="{{ 'role' + i }}" [checked]="role.is_checked" (change)="onChangeRoles($event, role)" />
                            <checkbox-text>{{ role.name }}</checkbox-text>
                          </app-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required"> Основная роль </span>
                    </div>
                    <div class="grid__box grid__box--size-5">
                      <input type="hidden" formControlName="default_group_id" />
                      <app-select
                        [items]="rolesChecked"
                        (callback)="onChangeDefaultRole($event)"
                        [textKey]="'name'"
                        [defaultText]="'Выберите основную роль'"
                        [initBy]="defaultRoleSelected"
                        [isDisabled]="rolesChecked && rolesChecked.length < 2"
                        [name]="'defaultGroupId'"
                      ></app-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid mt-24 mb-24">
        <div class="grid__box--size-4">
          <div class="grid">
            <div class="grid__box grid__box--size-5">
              <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">Участки</div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-12">
                  <div *ngIf="!rolesBlock.length" class="text-italic color-gray-dark">Выберите роль, чтобы отобразить поля участков.</div>
                  <div *ngIf="rolesBlock.length">
                    <div *ngFor="let roleBlock of rolesBlock; let last = last" [ngClass]="{ 'mb-24': !last }">
                      <div class="color-gray-dark tt-uppercase">Для роли "{{ roleBlock.name }}"</div>
                      <div class="mt-16">
                        <div class="grid">
                          <div class="grid__box grid__box--size-3">
                            <span class="title title-vertical title--s title--required">Регион</span>
                          </div>
                          <div class="grid__box grid__box--size-9">
                            <ng-container *ngIf="roleBlock.data.regions.length && roleBlock.selected.regions.length < roleBlock.data.regions.length">
                              <span class="mb-4" *ngFor="let region of roleBlock.selected.regions; let last = last">
                                {{ region.region }}
                                <span *ngIf="!last">, </span>
                              </span>
                            </ng-container>
                            <ng-container *ngIf="roleBlock.data.regions.length && roleBlock.selected.regions.length === roleBlock.data.regions.length">
                              <div class="mb-4">Все регионы</div>
                            </ng-container>
                            <app-search-popover
                              [items]="roleBlock.data.regions"
                              [isLoading]="roleBlock.options.regions.isLoading"
                              [textKey]="'region'"
                              [checkedKey]="'is_checked'"
                              [mode]="roleBlock.options.regions.mode"
                              (onClose)="onCloseSearchPopover(roleBlock, 'regions')"
                            ></app-search-popover>
                          </div>
                        </div>
                      </div>
                      <div class="mt-16">
                        <div class="grid">
                          <div class="grid__box grid__box--size-3">
                            <span class="title title-vertical title--s title--required">Филиал</span>
                          </div>
                          <div class="grid__box grid__box--size-9">
                            <ng-container *ngIf="roleBlock.data.branches.length && roleBlock.selected.branches.length < roleBlock.data.branches.length">
                              <span class="mb-4" *ngFor="let branch of roleBlock.selected.branches; let last = last">
                                {{ branch.mb_name }}
                                <span *ngIf="!last">, </span>
                              </span>
                            </ng-container>
                            <ng-container *ngIf="roleBlock.data.branches.length && roleBlock.selected.branches.length === roleBlock.data.branches.length">
                              <div class="mb-4">Все филиалы</div>
                            </ng-container>
                            <app-search-popover
                              [items]="roleBlock.data.branches"
                              [isLoading]="roleBlock.options.branches.isLoading"
                              [textKey]="'mb_name'"
                              [checkedKey]="'is_checked'"
                              [mode]="roleBlock.options.branches.mode"
                              [emptyItemsMessage]="'Для выбора филиала выберите регион в этом блоке'"
                              (onClose)="onCloseSearchPopover(roleBlock, 'branches')"
                            ></app-search-popover>
                          </div>
                        </div>
                      </div>
                      <div class="mt-16">
                        <div class="grid">
                          <div class="grid__box grid__box--size-3">
                            <span class="title title-vertical title--s title--required">Участок</span>
                          </div>
                          <div class="grid__box grid__box--size-9">
                            <ng-container *ngIf="roleBlock.data.sectors.length && roleBlock.selected.sectors.length <= roleBlock.data.sectors.length">
                              <span class="mb-4" *ngFor="let sector of roleBlock.selected.sectors; let last = last">
                                {{ sector.sector_number_str }}
                                <span *ngIf="!last">, </span>
                              </span>
                            </ng-container>
                            <app-search-popover
                              [items]="roleBlock.data.sectors"
                              [isLoading]="roleBlock.options.sectors.isLoading"
                              [textKey]="'sector_number_str'"
                              [checkedKey]="'is_checked'"
                              [mode]="roleBlock.options.sectors.mode"
                              [emptyItemsMessage]="'Для выбора участка выберите компанию (Шаг 1), и филиал в этом блоке'"
                              (onClose)="onCloseSearchPopover(roleBlock, 'sectors')"
                            ></app-search-popover>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </step>
    <step [title]="'Шаг 3'" [description]="'Дополнительные данные<br>Сведения об изменении профиля'">
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">
            Дополнительные<br />
            данные
          </div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid">
                <div class="grid__box grid__box--size-12">
                  <div class="grid grid--va-middle">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required"> Тип сотрудника </span>
                    </div>
                    <div class="grid__box grid__box--size-4">
                      <input type="hidden" formControlName="employee_type" />
                      <app-select
                        [items]="userTypes"
                        (callback)="onChangeUserType($event)"
                        [textKey]="'et_name'"
                        [defaultText]="'Выберите тип'"
                        [nullChoice]="false"
                        [initBy]="userTypeSelected"
                        [name]="'employeeType'"
                      ></app-select>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required"> Текущий статус </span>
                    </div>
                    <div class="grid__box grid__box--size-4">
                      <input type="hidden" formControlName="status" />
                      <app-select
                        [items]="userStatuses"
                        (callback)="onChangeUserStatus($event)"
                        [textKey]="'es_name'"
                        [defaultText]="'Выберите статус'"
                        [nullChoice]="false"
                        [initBy]="userStatusSelected"
                        [name]="'status'"
                      ></app-select>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required"> Дата приема на работу </span>
                    </div>
                    <div class="grid__box grid__box--size-3">
                      <input type="hidden" id="hireDate" formControlName="hire_date" />
                      <app-date-time-picker
                        [initDate]="startWorkDateObj.initDate"
                        [datepickerName]="'startWorkDate'"
                        [options]="startWorkDateOptions"
                        (dateCallback)="onChangeStartWorkDate($event)"
                      ></app-date-time-picker>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required"> Дата увольнения </span>
                    </div>
                    <div class="grid__box grid__box--size-3">
                      <input type="hidden" id="dismissalDate" formControlName="dismissal_date" />
                      <app-date-time-picker
                        [initDate]="endWorkDateObj.initDate"
                        [datepickerName]="'endWorkDate'"
                        [options]="endWorkDateOptions"
                        [isDisabled]="isEndWorkDateDisabled"
                        (dateCallback)="onChangeEndWorkDate($event)"
                      ></app-date-time-picker>
                    </div>
                  </div>
                  <div class="grid mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s title--required">
                        Причина<br />
                        увольнения
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <app-field>
                        <textarea class="input-textarea" rows="4" id="dismissalReason" formControlName="dismissal_reason"></textarea>
                      </app-field>
                    </div>
                  </div>
                  <div class="grid grid--va-middle mt-16">
                    <div class="grid__box grid__box--size-3">
                      <span class="title title-vertical title--s">
                        Номер<br />
                        удостоверения
                      </span>
                    </div>
                    <div class="grid__box grid__box--size-8">
                      <app-field>
                        <input class="input-text" type="text" id="tokenNumber" formControlName="token_number" fieldTrim />
                      </app-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid mt-24 mb-24">
        <div class="grid__box--size-4">
          <div class="grid">
            <div class="grid__box grid__box--size-5">
              <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid">
        <div class="grid__box grid__box--size-2">
          <div class="title">
            Сведения об<br />
            изменении профиля
          </div>
        </div>
        <div class="grid__box grid__box--size-10">
          <div class="grid">
            <div class="grid__box grid__box--size-7">
              <div class="grid grid--va-middle">
                <div class="grid__box grid__box--size-3">
                  <span class="title title--vertical title--s">Дата создания</span>
                </div>
                <div class="grid__box grid__box--size-9">
                  <div *ngIf="isEditMode">
                    {{ currentSelectedUser.employee.create_date | dateFormat: 'DD MMMM YYYY г.HH:mm' }}
                  </div>
                  <div *ngIf="!isEditMode">
                    <div class="mdash"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid mt-16 grid--va-middle">
            <div class="grid__box grid__box--size-7">
              <div class="grid grid--va-middle">
                <div class="grid__box grid__box--size-3">
                  <span class="title title--vertical title--s">Дата изменения</span>
                </div>
                <div class="grid__box grid__box--size-9">
                  <div *ngIf="isEditMode">
                    <span *ngIf="currentSelectedUser.employee.update_date">
                      {{ currentSelectedUser.employee.update_date | dateFormat: 'DD MMMM YYYY г. HH:mm' }}
                    </span>
                    <div class="mdash" *ngIf="!currentSelectedUser.employee.update_date"></div>
                  </div>
                  <div class="mdash" *ngIf="!isEditMode"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid mt-16 grid--va-middle">
            <div class="grid__box grid__box--size-7">
              <div class="grid grid--va-middle">
                <div class="grid__box grid__box--size-3">
                  <span class="title title--vertical title--s">Создал</span>
                </div>
                <div class="grid__box grid__box--size-9">
                  <div *ngIf="isEditMode && currentSelectedUser.employee.created_by_user">
                    <a
                      [routerLink]="[
                        '/users',
                        {
                          u_id: currentSelectedUser.employee.created_by_user.user_id
                        }
                      ]"
                      class="link"
                    >
                      {{ currentSelectedUser.employee.created_by_user.full_name }}
                    </a>
                  </div>
                  <div class="mdash" *ngIf="!isEditMode"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid mt-16 grid--va-middle">
            <div class="grid__box grid__box--size-7">
              <div class="grid grid--va-middle">
                <div class="grid__box grid__box--size-3">
                  <span class="title title--vertical title--s">Изменил</span>
                </div>
                <div class="grid__box grid__box--size-9">
                  <div *ngIf="isEditMode">
                    <span *ngIf="currentSelectedUser.employee.updated_by_user">
                      <a
                        [routerLink]="[
                          '/users',
                          {
                            u_id: currentSelectedUser.employee.updated_by_user.user_id
                          }
                        ]"
                        class="link"
                      >
                        {{ currentSelectedUser.employee.updated_by_user.full_name }}
                      </a>
                    </span>
                    <div class="mdash" *ngIf="!currentSelectedUser.employee.updated_by_user"></div>
                  </div>
                  <div class="mdash" *ngIf="!isEditMode"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid mt-16 grid--va-middle">
            <div class="grid__box grid__box--size-7">
              <div class="grid grid--va-middle">
                <div class="grid__box grid__box--size-3">
                  <span class="title title--vertical title--s">Версия</span>
                </div>
                <div class="grid__box grid__box--size-9">
                  <div *ngIf="isEditMode">
                    {{ versions[versions.length - 1] }}
                  </div>
                  <div *ngIf="!isEditMode">1.0</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </step>
    <steps-errors [fieldsInvalid]="fieldsInvalid"
                  [fieldsDescription]="fieldsDescription"
                  [backendError]="backendError"
                  [duplicationError]="duplicationError">
    </steps-errors>
  </steps>
</form>

<ng-template #uploadFileDescription>
  Цветное изображение на белом<br />
  фоне, формат 3,5х4,5 мм, размер<br />
  800х600 px, разрешение 72 dpi.<br />
  Формат JPG или PNG.
</ng-template>
